import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.profile.info;
//VERIFY IF THE JWT IS SET
const getMemberOnlineStatus = createSelector(
  getData,
  info => info.status === "online"
);
export default getMemberOnlineStatus;



// WEBPACK FOOTER //
// ./src/_selectors/profileSelectors/getMemberOnlineStatus.js